// extracted by mini-css-extract-plugin
module.exports = {"item":"ItemToken_item__2RPgE","row":"ItemToken_row__1o4rz","col1":"ItemToken_col1__3ldIB","col2":"ItemToken_col2__1X4Fd"};